import logo from "./../../assets/st-app-icon.svg";
import { useEffect, useState } from "react";
import "./PageLoader.scss";

function PageLoader() {
  const [dots, setDots] = useState("");
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return "";
        return prev + ".";
      });
    }, 500);

    // Set completion state after animation duration
    const completionTimer = setTimeout(() => {
      setIsComplete(true);
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(completionTimer);
    };
  }, []);

  return (
    <div className="page_loader">
      <div className="loader-container">
        <div className="image-block">
          <img
            style={{ width: "40px", height: "40px" }}
            src={logo}
            alt="logo"
            className="logo-image"
          />
        </div>
        <div className="loading-text min-w-[80px]">
          {isComplete ? "" : `Loading${dots}`}
        </div>
        <div className="loading-bar">
          <div className="loading-progress"></div>
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
